export enum ModulesNamesFR {
  MyAcademicLife = 'Ma Vie Académique',
  MyProfessionalLife = 'Ma Vie Professionnelle',
  MyInternationalLife = 'Mon Expatriation',
  Administrative = 'Administratif',
  PracticalLife = 'Vie Pratique',
  ListeningAndHealth = 'Écoute et Santé',
}

export enum ModulesNamesEN {
  MyAcademicLife = 'My Academic Life',
  MyProfessionalLife = 'My Professional Life',
  MyInternationalLife = 'My International Life',
  Administrative = 'Administrative',
  PracticalLife = 'Practical Life',
  ListeningAndHealth = 'Listening and Health',
}

export enum LinkTypeEnum {
  Ward = 'Ward',
  Wordpress = 'Wordpress',
  External = 'External',
}
